import { render, staticRenderFns } from "./CurrentConsents.vue?vue&type=template&id=b8b7277e"
import script from "./CurrentConsents.vue?vue&type=script&lang=ts"
export * from "./CurrentConsents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports